import React from 'react';
import CallsLayout from '$pages/$calls/@common/calls-layout';
import CallActions from 'actions/CallActions';
import CallsListComponent from '@components/calls-list/CallsListComponent';

class SelfCallsComponent extends React.Component {
  componentDidMount() {
    CallActions.setIsSearchingSelf(true);
  }

  componentWillUnmount() {
    CallActions.setIsSearchingSelf(false);
  }

  render() {
    return (
      <CallsLayout {...this.props}>
        <CallsListComponent />
      </CallsLayout>
    );
  }
}

export default SelfCallsComponent;
